// extracted by mini-css-extract-plugin
export default {"table":"Table-index__table--GIN1T","arrowButton":"Table-index__arrowButton--yF3Az","small":"Table-index__small--qfNbk"};